// // src/pages/modules/PopularItemsReportPage.jsx

// import React, { useEffect, useState, useCallback } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   fetchPopularItemsReport,
//   exportPopularItemsReport,
//   clearError,
// } from 'store/slices/reportSlice';

// import PageHeader from 'components/common/PageHeader';
// import { Card, CardHeader, CardTitle, CardContent } from 'components/ui/card';
// import { Badge } from 'components/ui/badge';
// import { TrendingUp, TrendingDown, Package, AlertTriangle, IndianRupee } from 'lucide-react';
// import { toast } from 'sonner';
// import LogDateFilter from 'components/common/LogDateFilter';
// import DataTable from 'components/common/DataTable';
// import { Loader2 } from 'lucide-react';

// const PopularItemsReportPage = () => {
//   const dispatch = useDispatch();

//   const {
//     popularItemsReport = { data: { summary: {}, most_popular: [], least_popular: [], results: [] }, pagination: null },
//     isLoading,
//     error,
//   } = useSelector((state) => state.report);

//   const summary = popularItemsReport.data.summary || {};
//   const mostPopular = popularItemsReport.data.most_popular || [];
//   const leastPopular = popularItemsReport.data.least_popular || [];
//   const results = popularItemsReport.data.results || [];
//   const pagination = popularItemsReport.pagination || {};

//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [dateFilters, setDateFilters] = useState({});

//   // Calculate total pages from server response
//   const totalPages = pagination.total_pages || 1;

//   const refetch = useCallback(() => {
//     dispatch(
//       fetchPopularItemsReport({
//         page,
//         page_size: pageSize,
//         search: searchTerm,
//         ...dateFilters,
//       })
//     );
//   }, [dispatch, page, pageSize, searchTerm, dateFilters]);

//   useEffect(() => {
//     refetch();
//   }, [refetch]);

//   useEffect(() => {
//     if (error) {
//       toast.error(error);
//       dispatch(clearError());
//     }
//   }, [error, dispatch]);

//   // Reset to page 1 when search term or page size changes
//   useEffect(() => {
//     setPage(1);
//   }, [searchTerm, pageSize]);

//   const columns = [
//     {
//       accessorKey: 'menu__name',
//       header: 'Menu Item',
//       cell: ({ row }) => (
//         <div className="flex items-center gap-2">
//           {/* <img
//             src={row.original.menu__profile_img || '/placeholder.jpg'}
//             alt={row.original.menu__name}
//             className="w-8 h-8 rounded-md object-cover"
//           /> */}
//           <span className="font-medium">{row.original.menu__name}</span>
//         </div>
//       ),
//     },
//     {
//       accessorKey: 'total_quantity',
//       header: 'Quantity Sold',
//       cell: ({ row }) => (
//         <Badge variant="outline" className="font-semibold">
//           {row.original.total_quantity}
//         </Badge>
//       ),
//     },
//     {
//       accessorKey: 'total_revenue',
//       header: 'Revenue (₹)',
//       cell: ({ row }) => (
//         <span className="font-semibold text-green-600">
//           ₹{(row.original.total_revenue || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//         </span>
//       ),
//     },
//     {
//       accessorKey: 'unique_orders',
//       header: 'Unique Orders',
//       cell: ({ row }) => (
//         <Badge variant="default">
//           {row.original.unique_orders}
//         </Badge>
//       ),
//     },
//     {
//       accessorKey: 'menu__price',
//       header: 'Price (₹)',
//       cell: ({ row }) => (
//         <span>₹{row.original.menu__price?.toLocaleString('en-IN')}</span>
//       ),
//     },
//     {
//       accessorKey: 'demand_status',
//       header: 'Demand Status',
//       cell: ({ row }) => {
//         const status = row.original.demand_status;
//         let variant = 'secondary';
//         if (status === 'in_stock') variant = 'default';
//         if (status === 'out_of_stock_high_demand') variant = 'destructive';
//         return <Badge variant={variant}>{status.replace('_', ' ').toUpperCase()}</Badge>;
//       },
//     },
//     {
//       accessorKey: 'is_high_demand_out_of_stock',
//       header: 'High Demand OOS',
//       cell: ({ row }) => (
//         <Badge variant={row.original.is_high_demand_out_of_stock ? 'destructive' : 'secondary'}>
//           {row.original.is_high_demand_out_of_stock ? 'Yes' : 'No'}
//         </Badge>
//       ),
//     },
//   ];

//   return (
//     <div className="space-y-6 animate-fade-in">
//       <PageHeader
//         title="Popular Items Report"
//         description="Top-selling menu items with demand analysis and out-of-stock risks"
//       />

//       <LogDateFilter onFilter={(f) => setDateFilters(f)} />

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">Total Menu Items</CardTitle>
//             <Package className="h-4 w-4 text-muted-foreground" />
//           </CardHeader>
//           <CardContent>
//             <div className="text-2xl font-bold">{summary.total_menus ?? 0}</div>
//           </CardContent>
//         </Card>

//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">In Stock</CardTitle>
//             <Badge variant="default">{summary.menus_in_stock ?? 0}</Badge>
//           </CardHeader>
//           <CardContent>
//             <div className="text-2xl font-bold text-green-600">
//               {summary.menus_in_stock ?? 0}
//             </div>
//           </CardContent>
//         </Card>

//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">Out of Stock</CardTitle>
//             <Badge variant="destructive">{summary.menus_out_of_stock ?? 0}</Badge>
//           </CardHeader>
//           <CardContent>
//             <div className="text-2xl font-bold text-destructive">
//               {summary.menus_out_of_stock ?? 0}
//             </div>
//           </CardContent>
//         </Card>

//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">High Demand OOS</CardTitle>
//             <AlertTriangle className="h-4 w-4 text-destructive" />
//           </CardHeader>
//           <CardContent>
//             <div className="text-2xl font-bold text-destructive">
//               {summary.high_demand_out_of_stock_count ?? 0}
//             </div>
//           </CardContent>
//         </Card>

//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">Total Revenue</CardTitle>
//             <IndianRupee className="h-4 w-4 text-green-600" />
//           </CardHeader>
//           <CardContent>
//             <div className="text-2xl font-bold text-green-600">
//               ₹{(summary.total_revenue || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//             </div>
//           </CardContent>
//         </Card>
//       </div>

//       {/* Most Popular Section */}
//       <Card>
//         <CardHeader>
//           <CardTitle>Top Selling Items</CardTitle>
//         </CardHeader>
//         <CardContent>
//           {mostPopular.length > 0 ? (
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//               {mostPopular.map((item) => (
//                 <div key={item.menu__id} className="border rounded-lg p-4">
//                   <div className="flex items-center gap-4">
//                     <div>
//                       <h3 className="font-semibold">{item.menu__name}</h3>
//                       <p className="text-sm text-muted-foreground">
//                         ₹{item.menu__price.toLocaleString('en-IN')} • {item.total_quantity} sold
//                       </p>
//                     </div>
//                   </div>
//                   <div className="mt-4 flex gap-2">
//                     <Badge variant={item.menu__in_stock ? 'default' : 'destructive'}>
//                       {item.menu__in_stock ? 'In Stock' : 'Out of Stock'}
//                     </Badge>
//                     {item.is_high_demand_out_of_stock && (
//                       <Badge variant="destructive">High Demand OOS</Badge>
//                     )}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <p className="text-center text-muted-foreground">No popular items found</p>
//           )}
//         </CardContent>
//       </Card>

//       {/* Main Table */}
//       {isLoading && results.length === 0 ? (
//         <div className="flex items-center justify-center py-20">
//           <Loader2 className="h-10 w-10 animate-spin mr-3" />
//           <span className="text-lg">Loading popular items data...</span>
//         </div>
//       ) : (
//         <DataTable
//           data={results} // Use the paginated results from the server
//           columns={columns}
//           searchPlaceholder="Search by menu item name..."
//           onSearch={setSearchTerm}
//           showSearch={true}
//           pageIndex={page - 1} // Convert to 0-based index for DataTable
//           pageSize={pageSize}
//           pageCount={totalPages} // Use total pages from server response
//           onPageChange={(p) => setPage(p + 1)} // Convert back to 1-based index
//           onPageSizeChange={(newSize) => setPageSize(newSize)}
//           isLoading={isLoading}
//           onExport={() =>
//             dispatch(exportPopularItemsReport({ filters: { ...dateFilters, search: searchTerm } }))
//           }
//           showExport={true}
//           showImport={false}
//         />
//       )}
//     </div>
//   );
// };

// export default PopularItemsReportPage;


// src/pages/modules/PopularItemsReportPage.jsx

import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPopularItemsReport,
  exportPopularItemsReport,
  clearError,
} from 'store/slices/reportSlice';
import { fetchMenus } from 'store/slices/canteenSlice';

import PageHeader from 'components/common/PageHeader';
import { Card, CardHeader, CardTitle, CardContent } from 'components/ui/card';
import { Badge } from 'components/ui/badge';
import { Button } from 'components/ui/button';
import { Label } from 'components/ui/label';
import { Input } from 'components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'components/ui/select';
import { TrendingUp, TrendingDown, Package, AlertTriangle, IndianRupee, Filter, X, ChevronDown, ChevronUp } from 'lucide-react';
import { toast } from 'sonner';
import LogDateFilter from 'components/common/LogDateFilter';
import DataTable from 'components/common/DataTable';
import { Loader2 } from 'lucide-react';
import FormField from 'components/common/FormField';

const PopularItemsReportPage = () => {
  const dispatch = useDispatch();

  const {
    popularItemsReport = { data: { summary: {}, most_popular: [], least_popular: [], results: [] }, pagination: null },
    isLoading,
    error,
  } = useSelector((state) => state.report);

  const summary = popularItemsReport.data.summary || {};
  const mostPopular = popularItemsReport.data.most_popular || [];
  const leastPopular = popularItemsReport.data.least_popular || [];
  const results = popularItemsReport.data.results || [];
  const pagination = popularItemsReport.pagination || {};

  // Get menus from Redux state
  const menus = useSelector((state) => state.canteen?.menus || []);
  const menusLoading = useSelector((state) => state.canteen?.isLoading || false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFilters, setDateFilters] = useState({});
  const [isAdvancedFilterExpanded, setIsAdvancedFilterExpanded] = useState(false);

  // Advanced filter states
  const [advancedFilters, setAdvancedFilters] = useState({
    menu: 'all',
    include_zero_sales: true,
    only_in_stock: false,
    highlight_high_demand: true,
    demand_status: 'all',
    min_quantity: '',
    max_quantity: '',
    min_revenue: '',
    ordering: '-total_quantity',
  });

  // Calculate total pages from server response
  const totalPages = pagination.total_pages || 1;

  // Check if any advanced filters are active (excluding 'all' values)
  const hasActiveAdvancedFilters = Object.values(advancedFilters).some(value =>
    value !== '' && value !== 'all' && value !== '-total_quantity' && value !== true && value !== false
  );

  const refetch = useCallback(() => {
    // Build the API params object with all filters
    const apiParams = {
      page,
      page_size: pageSize,
      search: searchTerm,
      report_type: 'popular_items',
      ...dateFilters,
      // Add advanced filters with proper naming for the backend
      ...(advancedFilters.menu !== 'all' && { menu: advancedFilters.menu }),
      ...(advancedFilters.include_zero_sales !== undefined && { include_zero_sales: advancedFilters.include_zero_sales }),
      ...(advancedFilters.only_in_stock !== undefined && { only_in_stock: advancedFilters.only_in_stock }),
      ...(advancedFilters.highlight_high_demand !== undefined && { highlight_high_demand: advancedFilters.highlight_high_demand }),
      ...(advancedFilters.demand_status !== 'all' && { demand_status: advancedFilters.demand_status }),
      ...(advancedFilters.min_quantity && { min_quantity: advancedFilters.min_quantity }),
      ...(advancedFilters.max_quantity && { max_quantity: advancedFilters.max_quantity }),
      ...(advancedFilters.min_revenue && { min_revenue: advancedFilters.min_revenue }),
      ...(advancedFilters.ordering && { ordering: advancedFilters.ordering }),
    };

    dispatch(fetchPopularItemsReport(apiParams));
  }, [dispatch, page, pageSize, searchTerm, dateFilters, advancedFilters]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearError());
    }
  }, [error, dispatch]);

  // Reset to page 1 when search term, page size, or filters change
  useEffect(() => {
    setPage(1);
  }, [searchTerm, pageSize, dateFilters, advancedFilters]);

  // Fetch all menus on component mount
  useEffect(() => {
    dispatch(fetchMenus());
  }, [dispatch]);

  // --- Event Handlers ---
  const handleAdvancedFilterChange = (key, value) => {
    setAdvancedFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetAdvancedFilters = () => {
    setAdvancedFilters({
      menu: 'all',
      include_zero_sales: true,
      only_in_stock: false,
      highlight_high_demand: true,
      demand_status: 'all',
      min_quantity: '',
      max_quantity: '',
      min_revenue: '',
      ordering: '-total_quantity',
    });
  };

  const columns = [
    {
      accessorKey: 'menu__name',
      header: 'Menu Item',
      cell: ({ row }) => (
        <div className="flex items-center gap-2">
          <span className="font-medium">{row.original.menu__name}</span>
        </div>
      ),
    },
    {
      accessorKey: 'total_quantity',
      header: 'Quantity Sold',
      cell: ({ row }) => (
        <Badge variant="outline" className="font-semibold">
          {row.original.total_quantity}
        </Badge>
      ),
    },
    {
      accessorKey: 'total_revenue',
      header: 'Revenue (₹)',
      cell: ({ row }) => (
        <span className="font-semibold text-green-600">
          ₹{(row.original.total_revenue || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </span>
      ),
    },
    {
      accessorKey: 'unique_orders',
      header: 'Unique Orders',
      cell: ({ row }) => (
        <Badge variant="default">
          {row.original.unique_orders}
        </Badge>
      ),
    },
    {
      accessorKey: 'menu__price',
      header: 'Price (₹)',
      cell: ({ row }) => (
        <span>₹{row.original.menu__price?.toLocaleString('en-IN')}</span>
      ),
    },
    {
      accessorKey: 'demand_status_display',
      header: 'Demand Status',
      cell: ({ row }) => {
        const status = row.original.demand_status_display;
        let variant = 'secondary';
        if (status === 'in_stock') variant = 'default';
        if (status === 'out_of_stock_high_demand') variant = 'destructive';
        return <Badge variant={variant}>{status.replace('_', ' ').toUpperCase()}</Badge>;
      },
    },
    // {
    //   accessorKey: 'is_high_demand_out_of_stock',
    //   header: 'High Demand OOS',
    //   cell: ({ row }) => (
    //     <Badge variant={row.original.is_high_demand_out_of_stock ? 'destructive' : 'secondary'}>
    //       {row.original.is_high_demand_out_of_stock ? 'Yes' : 'No'}
    //     </Badge>
    //   ),
    // },
  ];

  return (
    <div className="space-y-6 animate-fade-in">
      <PageHeader
        title="Popular Items Report"
        description="Top-selling menu items with demand analysis and out-of-stock risks"
      />

      <LogDateFilter onFilter={(f) => setDateFilters(f)} />

      {/* Advanced Filters Card */}
      <Card>
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <CardTitle className="text-lg flex items-center gap-2">
              <Filter className="h-5 w-5" />
              Advanced Filters
              {hasActiveAdvancedFilters && (
                <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                  Active
                </span>
              )}
            </CardTitle>
            <div className="flex gap-2">
              {hasActiveAdvancedFilters && (
                <Button variant="outline" size="sm" onClick={resetAdvancedFilters}>
                  <X className="h-4 w-4 mr-1" />
                  Reset
                </Button>
              )}
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setIsAdvancedFilterExpanded(!isAdvancedFilterExpanded)}
              >
                {isAdvancedFilterExpanded ? (
                  <>
                    Hide <ChevronUp className="h-4 w-4 ml-1" />
                  </>
                ) : (
                  <>
                    Show <ChevronDown className="h-4 w-4 ml-1" />
                  </>
                )}
              </Button>
            </div>
          </div>
        </CardHeader>
        {isAdvancedFilterExpanded && (
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {/* <div className="space-y-2">
                <Label htmlFor="menu">Menu Item</Label>
                <Select
                  value={advancedFilters.menu}
                  onValueChange={(value) => handleAdvancedFilterChange('menu', value)}
                  disabled={menusLoading}
                >
                  <SelectTrigger>
                    <SelectValue placeholder={menusLoading ? "Loading..." : "Select menu item"} />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All Menu Items</SelectItem>
                    {Array.isArray(menus) && menus.map((menu) => (
                      <SelectItem key={menu.id} value={menu.id}>
                        {menu.name} - ₹{menu.price}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div> */}

              {/* <FormField
  label="Menu Item"
  name="menu"
  type="select"
  value={advancedFilters.menu}
  onChange={(e) => handleAdvancedFilterChange('menu', e.target.value)}
  disabled={menusLoading}
  options={[
    { value: 'all', label: 'All Menu Items' },
    ...(Array.isArray(menus)
      ? menus.map((menu) => ({
          value: String(menu.id),
          label: `${menu.name} - ₹${menu.price}`,
        }))
      : []),
  ]}
  placeholder={menusLoading ? "Loading..." : "Select menu item"}
/> */}


              <div className="space-y-2">
                <Label htmlFor="demand_status">Demand Status</Label>
                <Select
                  value={advancedFilters.demand_status}
                  onValueChange={(value) => handleAdvancedFilterChange('demand_status', value)}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select demand status" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    <SelectItem value="in_stock">In Stock</SelectItem>
                    <SelectItem value="out_of_stock_high_demand">Out of Stock (High Demand)</SelectItem>
                    <SelectItem value="out_of_stock_low_demand">Out of Stock (Low Demand)</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label htmlFor="ordering">Sort By</Label>
                <Select
                  value={advancedFilters.ordering}
                  onValueChange={(value) => handleAdvancedFilterChange('ordering', value)}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select sorting" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="-total_quantity">Quantity (High to Low)</SelectItem>
                    <SelectItem value="total_quantity">Quantity (Low to High)</SelectItem>
                    <SelectItem value="-total_revenue">Revenue (High to Low)</SelectItem>
                    <SelectItem value="total_revenue">Revenue (Low to High)</SelectItem>
                    <SelectItem value="menu__price">Price (Low to High)</SelectItem>
                    <SelectItem value="-menu__price">Price (High to Low)</SelectItem>
                    <SelectItem value="menu__name">Name (A to Z)</SelectItem>
                    <SelectItem value="-menu__name">Name (Z to A)</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label>Quantity Range</Label>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <Input
                      type="number"
                      placeholder="Min"
                      value={advancedFilters.min_quantity}
                      onChange={(e) => handleAdvancedFilterChange('min_quantity', e.target.value)}
                    />
                  </div>
                  <div>
                    <Input
                      type="number"
                      placeholder="Max"
                      value={advancedFilters.max_quantity}
                      onChange={(e) => handleAdvancedFilterChange('max_quantity', e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="min_revenue">Min Revenue (₹)</Label>
                <Input
                  type="number"
                  placeholder="Enter minimum revenue"
                  value={advancedFilters.min_revenue}
                  onChange={(e) => handleAdvancedFilterChange('min_revenue', e.target.value)}
                />
              </div>

              {/* <div className="space-y-2">
                <Label>Display Options</Label>
                <div className="space-y-2">
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id="include_zero_sales"
                      checked={advancedFilters.include_zero_sales}
                      onChange={(e) => handleAdvancedFilterChange('include_zero_sales', e.target.checked)}
                    />
                    <Label htmlFor="include_zero_sales">Include zero sales items</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id="only_in_stock"
                      checked={advancedFilters.only_in_stock}
                      onChange={(e) => handleAdvancedFilterChange('only_in_stock', e.target.checked)}
                    />
                    <Label htmlFor="only_in_stock">Only in-stock items</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id="highlight_high_demand"
                      checked={advancedFilters.highlight_high_demand}
                      onChange={(e) => handleAdvancedFilterChange('highlight_high_demand', e.target.checked)}
                    />
                    <Label htmlFor="highlight_high_demand">Highlight high demand items</Label>
                  </div>
                </div>
              </div> */}
            </div>
          </CardContent>
        )}
      </Card>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Menu Items</CardTitle>
            <Package className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{summary.total_menus ?? 0}</div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">In Stock</CardTitle>
            <Badge variant="default">{summary.menus_in_stock ?? 0}</Badge>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-green-600">
              {summary.menus_in_stock ?? 0}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Out of Stock</CardTitle>
            <Badge variant="destructive">{summary.menus_out_of_stock ?? 0}</Badge>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-destructive">
              {summary.menus_out_of_stock ?? 0}
            </div>
          </CardContent>
        </Card>

        {/* <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">High Demand OOS</CardTitle>
            <AlertTriangle className="h-4 w-4 text-destructive" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-destructive">
              {summary.high_demand_out_of_stock_count ?? 0}
            </div>
          </CardContent>
        </Card> */}

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Revenue</CardTitle>
            <IndianRupee className="h-4 w-4 text-green-600" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-green-600">
              ₹{(summary.total_revenue || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Most Popular Section */}
      <Card>
        <CardHeader>
          <CardTitle>Top Selling Items</CardTitle>
        </CardHeader>
        <CardContent>
          {mostPopular.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {mostPopular.map((item) => (
                <div key={item.menu__id} className="border rounded-lg p-4">
                  <div className="flex items-center gap-4">
                    <div>
                      <h3 className="font-semibold">{item.menu__name}</h3>
                      <p className="text-sm text-muted-foreground">
                        ₹{item.menu__price?.toLocaleString('en-IN')} • {item.total_quantity} sold
                      </p>
                    </div>
                  </div>
                  <div className="mt-4 flex gap-2">
                    <Badge variant={item.menu__in_stock ? 'default' : 'destructive'}>
                      {item.menu__in_stock ? 'In Stock' : 'Out of Stock'}
                    </Badge>
                    {item.is_high_demand_out_of_stock && (
                      <Badge variant="destructive">High Demand OOS</Badge>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-muted-foreground">No popular items found</p>
          )}
        </CardContent>
      </Card>

      {/* Main Table */}
      {/* {isLoading && results.length === 0 ? (
        <div className="flex items-center justify-center py-20">
          <Loader2 className="h-10 w-10 animate-spin mr-3" />
          <span className="text-lg">Loading popular items data...</span>
        </div>
      ) : ( */}
      <DataTable
        data={results} // Use paginated results from the server
        columns={columns}
        totalCount={pagination.count}
        searchPlaceholder="Search by menu item name..."
        onSearch={setSearchTerm}
        showSearch={true}
        pageIndex={page - 1} // Convert to 0-based index for DataTable
        pageSize={pageSize}
        pageCount={totalPages} // Use total pages from server response
        onPageChange={(p) => setPage(p + 1)} // Convert back to 1-based index
        onPageSizeChange={(newSize) => setPageSize(newSize)}
        isLoading={isLoading}
        onExport={() =>
          dispatch(exportPopularItemsReport({
            filters: {
              page,
              page_size: pageSize,
              search: searchTerm,
              report_type: 'popular_items',
              ...dateFilters,
              // Include advanced filters in export
              ...(advancedFilters.menu !== 'all' && { menu: advancedFilters.menu }),
              ...(advancedFilters.include_zero_sales !== undefined && { include_zero_sales: advancedFilters.include_zero_sales }),
              ...(advancedFilters.only_in_stock !== undefined && { only_in_stock: advancedFilters.only_in_stock }),
              ...(advancedFilters.highlight_high_demand !== undefined && { highlight_high_demand: advancedFilters.highlight_high_demand }),
              ...(advancedFilters.demand_status !== 'all' && { demand_status: advancedFilters.demand_status }),
              ...(advancedFilters.min_quantity && { min_quantity: advancedFilters.min_quantity }),
              ...(advancedFilters.max_quantity && { max_quantity: advancedFilters.max_quantity }),
              ...(advancedFilters.min_revenue && { min_revenue: advancedFilters.min_revenue }),
              ...(advancedFilters.ordering && { ordering: advancedFilters.ordering }),
            }
          }))
        }
        showExport={true}
        showImport={false}
      />
      {/* )} */}
    </div>
  );
};

export default PopularItemsReportPage;